(ns pfo.specutil
  (:require
    [malli.core :as m]
    [malli.dev.pretty :as pretty]))

(defn fail-if-invalid!
  "Validates value against schema.
   Pretty-prints the error and throws when invalid."
  [schema value label]
  (when-let [explanation (m/explain schema value)]
    (js/console.error (str "❌ " label))
    (pretty/explain schema value)
    (throw (ex-info label explanation))))

(defn warn-if-invalid
  [schema value label]
  (when-let [_ (m/explain schema value)]
    (js/console.error (str "❌ " label))
    (pretty/explain schema value)))
